// Bài hướng dẫn trang Bàn làm việc QC — /qc-desk (QĐ 0521, 03/11/2026).
//
// ⚠️ Ranh giới thông tin ở `../types.ts` áp NGUYÊN VẸN.

import type { GuideBook } from "../types";

export const QC_DESK_GUIDES: GuideBook = {
  qc_desk: {
    purpose:
      "Trang mở đầu ngày làm việc của người kiểm chất lượng: gom việc của đúng nghề mình, mỗi việc một nút đi thẳng tới chỗ làm.",
    where: [
      'Mục "Bàn làm việc QC" đứng đầu nhóm "Chất lượng" trong menu. Mở app thì QC vào thẳng màn làm việc chính: QC sửa hình, QC chụp ảnh, QC trang điểm vào "Chấm bài"; QC cơ sở vào "Kiểm cơ sở"; QC CSKH vào "Soi hành trình khách". Bàn làm việc vẫn mở được từ menu.',
      'Đầu trang ghi "Bàn làm việc —" kèm loại QC của bạn (QC chụp ảnh, QC sửa hình, QC trang điểm, QC cơ sở, QC CSKH) và một dòng nói bạn kiểm ai.',
      'Dải đỏ "Có bài sắp tới hạn khoá sổ" hiện dưới đầu trang khi bài bạn đang cầm còn từ 3 ngày trở xuống tới hạn.',
      'Khối "Việc của nghề mình": các thẻ việc riêng của loại QC. QC chụp ảnh có "Chấm ảnh chụp", "Ảnh thẻ", "Hậu kiểm ảnh gốc", "Kiểm cơ sở — khu chụp". QC sửa hình có "Chấm ảnh sửa", "Hậu kiểm ảnh gốc", "Đơn đang ở hậu kỳ". QC trang điểm có "Chấm trang điểm", "Kiểm cơ sở — khu trang điểm". QC cơ sở có "Kiểm cơ sở — cả 4 khu", "Ca lễ tân", "Bảng quầy ảnh thẻ". QC CSKH có "Soi hành trình khách", "Phiếu tuần CSKH", "Đánh giá khách".',
      'Khối "Việc chung của QC": "Phiếu đồng phục", "Khiếu nại". Khối "Kết quả của tôi": "Bảng QC — phần của tôi".',
      'Mỗi thẻ có tên việc, con số đang chờ (nếu có), một dòng giải thích và một nút xanh. Thẻ viền đứt có chữ "MỚI" là hai mục mới của QC chụp ảnh.',
      'Nút "Mở danh sách" ở thẻ "Hậu kiểm ảnh gốc" mở trang soi ảnh gốc (thẻ đơn có ảnh, màn soi tại chỗ); nút "Mở mục Ảnh thẻ" mở trang Ảnh thẻ (thẻ bài ảnh thẻ có ảnh). Hai trang này cũng là hai mục riêng trong menu.',
    ],
    howItWorks: [
      "Trang tự chọn bộ thẻ theo phòng của bạn trên hồ sơ nhân sự. Đổi phòng là đổi bộ thẻ, không cần làm gì.",
      'Con số do máy tự đếm mỗi lần mở trang. "Chấm ảnh chụp" và "Ảnh thẻ" đếm bài bạn đang cầm, tách theo đơn có phải ảnh thẻ không. "Chấm ảnh sửa" và "Chấm trang điểm" đếm mọi bài bạn đang cầm. "Hậu kiểm ảnh gốc" đếm đơn chụp trong 30 ngày gần nhất mà chưa ai chấm Đạt / Không đạt ảnh gốc, trong các cơ sở bạn phụ trách. Đơn cũ hơn không vào danh sách — cần soi thì mở trang đơn. "Soi hành trình khách" đếm ca đang chờ soi. "Phiếu tuần CSKH" đếm người chưa có phiếu nào trong tháng.',
      "Thẻ không có số thì bấm nút để xem việc ở trang đó.",
      'Bấm "Chấm bài" ở thẻ "Chấm ảnh chụp", hay "Chấm" ở trang Ảnh thẻ, là mở thẻ Chấm bài chỉ hiện đúng nhóm bài đó. Bấm "Xem tất cả" để thấy đủ. Nút nhận thêm bài vẫn giao bài theo nghề như cũ, nên bài mới nhận có thể thuộc nhóm còn lại.',
      'Danh sách "Hậu kiểm ảnh gốc" dùng chung cho QC chụp ảnh và QC sửa hình. Bấm mã đơn để mở đơn và chấm Đạt / Không đạt ở đó; quay lại thì đơn vừa soi tự biến khỏi danh sách.',
      "Bạn không mở được trang nào thì thẻ dẫn tới trang đó không hiện.",
      'Menu của người kiểm chất lượng đã bỏ các mục không đúng nghề: "Ca vận hành", "Chấm công", "Nhân sự", "Năng suất nhân sự", "Điều hành khung", "Concept & Trang phục", "KPI chi nhánh". Giờ công của chính bạn vẫn xem ở trang Của tôi. Bấm đường dẫn tới các trang đó từ thông báo vẫn mở được.',
    ],
    statuses: [
      { label: "MỚI", meaning: "Mục mới mở thêm cho QC chụp ảnh: Ảnh thẻ, Hậu kiểm ảnh gốc." },
      { label: "…", meaning: "Con số đang tải." },
      { label: "Chữ đỏ trong thẻ", meaning: "Không tải được số của thẻ đó; các thẻ khác vẫn dùng được. Lời đỏ nói đúng lý do." },
      {
        label: "Bạn chưa được gán phòng QC — nhờ Nhân sự gán ở HRM",
        meaning: "Hồ sơ của bạn chưa có phòng QC nên trang chưa biết bạn là loại QC nào.",
      },
      {
        label: "Không còn đơn nào chờ soi ảnh gốc trong 30 ngày gần nhất",
        meaning: "Trang Hậu kiểm ảnh gốc: mọi đơn chụp trong 30 ngày qua ở cơ sở bạn phụ trách đã được soi.",
      },
    ],
    blocks: [
      {
        for: ["qc"],
        title: "Việc của người kiểm chất lượng: bắt đầu ngày làm việc",
        steps: [
          'Mở menu, bấm "Bàn làm việc QC". Mở app thì bạn vào thẳng màn làm việc chính của mình, không qua trang này.',
          "Có dải đỏ thì chấm các bài sắp tới hạn khoá sổ trước.",
          'Làm lần lượt các thẻ trong khối "Việc của nghề mình", thẻ có số lớn trước.',
          'QC chụp ảnh và QC sửa hình: bấm "Mở danh sách" ở thẻ "Hậu kiểm ảnh gốc" (hoặc mục cùng tên trong menu), bấm "Bắt đầu soi từ đơn cũ nhất", chấm Đạt / Không đạt từng đơn.',
          'QC chụp ảnh: bài ảnh thẻ nằm ở mục "Ảnh thẻ", tách khỏi bài album.',
        ],
        troubles: [
          "Không thấy thẻ Hậu kiểm ảnh gốc → chỉ QC chụp ảnh và QC sửa hình có thẻ này; đúng loại đó mà vẫn không thấy thì nhờ Nhân sự kiểm phòng trên hồ sơ.",
          "Thẻ báo chữ đỏ → tải lại trang; vẫn đỏ thì chụp lời đỏ gửi quản lý trực tiếp.",
          "Đầu trang ghi sai loại QC → phòng trên hồ sơ đang sai; nhờ Nhân sự sửa ở HRM.",
        ],
      },
      {
        for: ["exec", "lead"],
        title: "Cấp quản lý đọc trang này thế nào",
        steps: [
          "Trang chỉ mở cho người kiểm chất lượng. Muốn xem việc của từng QC, mở Bảng QC.",
          "Loại QC đi theo phòng trên hồ sơ nhân sự ở HRM: đổi phòng ở HRM là đổi bộ thẻ của người đó.",
        ],
      },
    ],
    askWho: "Thiếu thẻ hay sai loại QC thì hỏi quản lý trực tiếp, hoặc Nhân sự để kiểm phòng trên hồ sơ.",
  },

  // Mục menu "Hậu kiểm ảnh gốc" (QĐ 0521): QC sửa hình (CEO 2a) và QC chụp ảnh
  // (vòng 3 · 3a); màn thẻ có ảnh + màn soi tại chỗ (vòng 3 · 1a).
  qc_raw_review: {
    purpose: "Soi ảnh gốc của các đơn chụp trong 30 ngày gần nhất mà chưa ai soi, chấm Đạt / Không đạt từng đơn ngay trên một màn.",
    where: [
      'Mục "Hậu kiểm ảnh gốc" trong nhóm "Chất lượng" của menu, ngay dưới "Chấm điểm" (QC sửa hình và QC chụp ảnh).',
      'Đầu trang: dòng "Còn … đơn chờ soi ảnh gốc", nút "Bắt đầu soi từ đơn cũ nhất", hai nút lọc "Tất cả" và "Chờ quá 3 ngày".',
      "Giữa trang: mỗi đơn là một thẻ có 4 ảnh gốc nhỏ, mã đơn, sản phẩm, cơ sở, ngày chụp, số ảnh. Thẻ và màn soi KHÔNG ghi tên thợ chụp để soi công bằng; kết quả vẫn lưu trên đơn, nơi đã ghi sẵn thợ của buổi đó. Thẻ đơn chờ lâu có nhãn vàng \"Chờ … ngày\".",
      'Bấm một thẻ là mở màn soi: thanh trên có "‹ Danh sách", "Đơn … / …", "‹ Đơn trước", "Đơn kế ›"; bên trái là lưới ảnh gốc; bên phải là hai nút "✓ Đạt", "✕ Không đạt" và nút "Lưu, sang đơn kế ›". Trên điện thoại, nút lưu dính ở đáy màn.',
    ],
    howItWorks: [
      "Máy tự gom mỗi lần mở trang: chỉ đơn đã chụp xong mà ảnh gốc chưa ai chấm, trong các cơ sở bạn phụ trách, đơn cũ nhất đứng trước.",
      "Bấm một tấm trong lưới là phóng to, lướt trái / phải xem tấm khác.",
      'Chọn "✕ Không đạt" thì hiện các lý do để bấm chọn và ô "Ghi thêm"; chọn "Khác" thì phải ghi thêm mới lưu được.',
      'Bấm "Lưu, sang đơn kế ›" là ghi kết quả, máy tự mở đơn kế; đơn vừa chấm rời danh sách. Hết đơn thì quay về danh sách.',
      'Đơn mà thợ chỉ dán link ảnh ngoài thì thẻ ghi "Ảnh gốc ở link ngoài"; trong màn soi có nút "Mở link ảnh gốc ↗", xem xong quay lại chấm.',
      "Trên máy tính có phím tắt: D chọn Đạt, K chọn Không đạt, mũi tên trái / phải sang đơn trước / đơn kế.",
      'Đơn đã chốt concept thì đầu màn soi có khối viền vàng "Concept khách đã chốt" với ảnh mẫu của concept đó, và dòng "… ảnh gốc · gói bao … ảnh chỉnh" — đối chiếu ảnh gốc với concept và số ảnh khách được nhận.',
      "QC chụp ảnh và QC sửa hình dùng chung một danh sách: một người chấm xong là đơn rời danh sách của cả hai.",
    ],
    statuses: [
      { label: "Chờ … ngày", meaning: "Đơn đã chụp quá 3 ngày mà chưa ai soi ảnh gốc." },
      { label: "Ảnh gốc ở link ngoài", meaning: "Ảnh gốc không nằm trong kho của đơn; mở link để xem." },
      { label: "Không còn đơn nào chờ soi ảnh gốc trong 30 ngày gần nhất", meaning: "Mọi đơn chụp trong 30 ngày qua ở cơ sở bạn phụ trách đã được soi. Đơn cũ hơn soi ở trang đơn." },
      { label: "Mục này dành cho QC chụp ảnh và QC sửa hình", meaning: "Vai của bạn không soi ảnh gốc." },
      { label: "Chữ đỏ", meaning: "Không tải được danh sách hay ảnh; lời đỏ nói đúng lý do." },
    ],
    blocks: [
      {
        for: ["qc"],
        title: "Việc của người kiểm chất lượng: soi ảnh gốc",
        steps: [
          'Bấm mục "Hậu kiểm ảnh gốc" trong menu.',
          'Bấm "Bắt đầu soi từ đơn cũ nhất" (hoặc bấm thẳng một thẻ).',
          "Xem lưới ảnh gốc, bấm tấm nào cần soi kỹ để phóng to.",
          'Chọn "✓ Đạt", hoặc "✕ Không đạt" rồi bấm chọn lý do (ghi thêm nếu cần).',
          'Bấm "Lưu, sang đơn kế ›" — máy tự mở đơn kế, làm tiếp tới hết.',
        ],
        troubles: [
          "Danh sách trống mà vẫn biết có đơn chưa soi → đơn đó ở cơ sở bạn không phụ trách; báo quản lý trực tiếp.",
          'Lưu không được và có chữ đỏ → thường là đơn vừa có người khác chấm; bấm "‹ Danh sách" để tải lại.',
          "Bấm nhầm kết quả → mở trang đơn, chấm lại ở khối \"Đánh giá ảnh\".",
        ],
      },
      {
        for: ["exec", "lead"],
        title: "Cấp quản lý đọc trang này thế nào",
        steps: [
          "Trang mở cho người kiểm chất lượng phòng ảnh, phòng hậu kỳ và tầng điều hành. Muốn xem QC làm tới đâu, mở Bảng QC.",
        ],
      },
    ],
    askWho: "Thấy đơn lạ hay danh sách sai cơ sở thì hỏi quản lý trực tiếp.",
  },

  // Mục "Ảnh thẻ" của QC chụp ảnh (QĐ 0521, vòng 3 · 2a · 3a): chính màn Chấm bài,
  // lọc sẵn bài ảnh thẻ, không còn trang trung gian.
  qc_journey: {
    purpose: "Soi trọn hành trình của một khách qua 9 khâu, từ lúc đặt lịch tới lúc chăm sau bán.",
    where: [
      'Mục "Soi hành trình khách" trong nhóm "Chất lượng" của menu, ngay dưới "Chấm điểm"; mở app là vào thẳng đây.',
      'Đầu trang: dòng "Còn … ca chờ soi", nút "Bắt đầu soi ca đầu tiên" và hàng nút lọc "Tất cả", "Khiếu nại", "Sao thấp", "Máy rút tuần này", "Đã soi".',
      "Giữa trang: mỗi ca là một thẻ có nhãn lý do, mã đơn, tên khách và dải 9 chấm (xanh đạt, đỏ không đạt, xám chưa soi).",
      'Trong màn soi: bên trái là 9 khâu xếp dọc, mỗi khâu có ba nút "Đạt", "Không đạt", "Không áp dụng"; bên phải là "Khách & tiền", "Khách chấm sao" và số khâu đã soi; dưới cùng là nút "Lưu kết quả soi".',
    ],
    howItWorks: [
      "Ca tự vào danh sách: đơn có khiếu nại, đơn có người bị khách chấm từ 3 sao trở xuống, và mỗi tuần vài đơn bình thường do máy chọn ngẫu nhiên.",
      "Mở một ca, mỗi khâu đã có sẵn giờ, người làm, chỗ trễ hạn (chữ đỏ) và lời khách nói — bạn đọc rồi chấm, không phải đi tra từng trang.",
      'Chọn "Không đạt" thì phải ghi lý do và chọn người chịu trong số người làm khâu đó.',
      "Đủ 9 khâu mới lưu được. Lưu xong máy tự mở ca kế; ca vừa soi sang mục \"Đã soi\" và không sửa lại được.",
      "Đơn không có khiếu nại: khâu Không đạt thành một phiếu lỗi trong sổ lỗi, chờ người có trách nhiệm xác nhận. Đơn đã có khiếu nại: lỗi bạn ghi chỉ là đề xuất gửi vào khiếu nại đó.",
    ],
    statuses: [
      { label: "Khiếu nại đang mở / Khiếu nại đã đóng", meaning: "Đơn có khiếu nại của khách." },
      { label: "…★ (tên khâu)", meaning: "Điểm thấp nhất khách chấm và khâu của người bị chấm." },
      { label: "Máy rút", meaning: "Đơn bình thường máy chọn ngẫu nhiên trong tuần để soi." },
      { label: "Chữ đỏ trong một khâu", meaning: "Chỗ trễ hạn hoặc thiếu việc hệ thống thấy được, ví dụ giao bản đầu trễ hay chưa gọi xác nhận." },
      { label: "Đề xuất (dải vàng)", meaning: "Ca có khiếu nại: lỗi bạn ghi được gửi vào khiếu nại, người xử khiếu nại chốt." },
      { label: "Đã lưu nhưng chưa ghi được lỗi", meaning: "Kết quả soi đã lưu, riêng phiếu lỗi của khâu đó chưa vào sổ — đọc lý do in kèm." },
    ],
    blocks: [
      {
        for: ["qc"],
        title: "Việc của người kiểm chất lượng CSKH: soi một ca",
        steps: [
          'Bấm "Bắt đầu soi ca đầu tiên" (ca khiếu nại và sao thấp đứng trước).',
          "Đọc từng khâu từ trên xuống: giờ, người làm, chữ đỏ, lời khách.",
          'Bấm "Đạt", "Không đạt" hoặc "Không áp dụng" cho từng khâu; trên máy tính có thể bấm phím 1, 2, 3 và mũi tên lên xuống.',
          'Khâu "Không đạt": ghi lý do và chọn người chịu.',
          'Bấm "Lưu kết quả soi" khi đủ 9 khâu; máy tự sang ca kế.',
        ],
        troubles: [
          'Nút lưu còn mờ → còn khâu chưa chấm, hoặc khâu "Không đạt" thiếu lý do hay người chịu.',
          "Không thấy tên người cần chọn → hệ thống không ghi người đó làm khâu này; ghi rõ trong lý do.",
          "Tên mình nằm trong danh sách người chịu → không tự ghi lỗi cho mình; để QC khác soi ca đó.",
          "Chữ đỏ trên trang → tải lại; vẫn đỏ thì chụp lời đỏ gửi quản lý trực tiếp.",
        ],
      },
      {
        for: ["exec", "lead"],
        title: "Cấp quản lý đọc trang này thế nào",
        steps: ["Trang chỉ mở cho người kiểm chất lượng CSKH. Phiếu lỗi sinh ra từ đây nằm trong sổ lỗi như mọi phiếu khác, chờ xác nhận."],
      },
    ],
    askWho: "Thấy số liệu của một khâu sai với thực tế thì báo quản lý trực tiếp kèm mã đơn.",
  },
  qc_idphoto: {
    purpose: "Chấm các bài ảnh thẻ bạn đang cầm, tách khỏi bài album.",
    where: [
      'Mục "Ảnh thẻ" trong nhóm "Chất lượng" của menu, ngay dưới "Hậu kiểm ảnh gốc".',
      'Đầu trang: dải "Bản sửa ảnh thẻ" với nút "Mở Việc thợ chụp ›".',
      'Dưới đó: tiêu đề "Ảnh thẻ", hai nút "Cho tôi thêm 5 bài" và "Nhận hết bài còn lại", dòng "Đang xem: bài ảnh thẻ".',
      "Giữa trang: mỗi bài là một thẻ có dải ảnh nhỏ, tên buổi, số người, số ảnh và hạn khoá sổ.",
    ],
    howItWorks: [
      "Trang chỉ hiện bài ảnh thẻ trong số bài bạn đang cầm; bài album vẫn ở mục \"Chấm điểm\".",
      "Bấm một thẻ là mở bài ngay tại đây: lưới ảnh bên trái, phiếu chấm bên phải, giống hệt bài album.",
      "Lưu phiếu xong máy tự mở bài kế; hết bài thì quay về danh sách.",
      'Nút "Cho tôi thêm 5 bài" rút theo nghề như ở "Chấm điểm", nên bài mới nhận có thể là bài album.',
    ],
    statuses: [
      { label: "Đang xem: bài ảnh thẻ", meaning: "Trang đang lọc, chỉ hiện bài ảnh thẻ." },
      { label: "còn … ngày khoá sổ", meaning: "Số ngày còn lại trước khi sổ tháng khoá; quá hạn thì bài không chấm được nữa." },
      { label: "Mục này dành cho QC chụp ảnh", meaning: "Vai của bạn không chấm ảnh thẻ." },
    ],
    blocks: [
      {
        for: ["qc"],
        title: "Việc của người kiểm chất lượng: chấm ảnh thẻ",
        steps: [
          'Bấm mục "Ảnh thẻ" trong menu.',
          "Bấm thẻ bài đầu tiên để mở.",
          "Xem ảnh, chấm từng mục của phiếu, rồi lưu; máy tự sang bài kế.",
          'Cần nộp bản sửa ảnh thẻ thì bấm "Mở Việc thợ chụp ›" ở đầu trang.',
        ],
        troubles: [
          "Không thấy thẻ nào → bạn chưa cầm bài ảnh thẻ; bấm \"Cho tôi thêm 5 bài\" hoặc mở \"Chấm điểm\" xem bài album.",
          "Chữ đỏ trên trang → tải lại; vẫn đỏ thì chụp lời đỏ gửi quản lý trực tiếp.",
        ],
      },
      {
        for: ["exec", "lead"],
        title: "Cấp quản lý đọc trang này thế nào",
        steps: ["Trang chỉ mở cho người kiểm chất lượng phòng ảnh. Muốn xem QC làm tới đâu, mở Bảng QC."],
      },
    ],
    askWho: "Thấy bài lạ hay ảnh không tải được thì hỏi quản lý trực tiếp.",
  },
};
